export class IssueModel {
    public IssueId: number;
    public SiteId: number;
    public Object: string;
    public Tenant: string;
    public Yta: string;
    public Phone: string;
    public ContactName: string;
    public Address: string;
    public Email: string;
    public ApartmentNumber: number;
    public Typ: string;

    public Image: string;
    public Description: string;
    public IsPolice: boolean;
    public Source: string;

    public AccountId: number;
    public IsSuccess: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/issue-model.ts